<template>
<!-- 店铺运营 -->
    <div>
        <div class="serviceContent">
            <!-- 顶部描述 -->
            <div class="scTopTip">
                <!-- <div>全渠道跨境电商代运营</div>
                <div>有别于一般单纯的运营服务，胤石更是品牌电商的合作伙伴，<br/>为每一个品牌配备专属的店站运营团队.并不断引入胤石技术和创新团队在数据分析<br/>和商业智能的成果， 为业务导向并对业绩负责。</div> -->
            </div>
            <!-- 公司信息 -->
            <div class="companyInfoAll">
                <div class="companyInfo"> 
                    <div class="wow fadeInLeft company" data-wow-delay=".3s">
                        <div class="companyImgInfo"><img loading="lazy" src="../../assets/img/industrialChain/daiyunying_jingyan.png" class="cimg1"/> <span>8年</span> </div>
                        <div class="companyDesc">运营经验</div>
                    </div>
                    <div class="wow fadeInLeft company" data-wow-delay=".1s">
                        <div class="companyImgInfo"><img loading="lazy" src="../../assets/img/industrialChain/daiyunying_fengongsi.png" class="cimg2"/> <span>30</span><a>+</a> </div>
                        <div class="companyDesc">胤石分公司</div>
                    </div>
                    <div class="wow fadeInRight company" data-wow-delay=".1s">
                        <div class="companyImgInfo"><img loading="lazy" src="../../assets/img/industrialChain/daiyunying_fugaihangyi.png" class="cimg3"/> <span>100</span> </div>
                        <div class="companyDesc">覆盖行业</div>
                    </div>
                    <div class="wow fadeInRight company" data-wow-delay=".3s">
                        <div class="companyImgInfo"><img loading="lazy" src="../../assets/img/industrialChain/daiyunying_hexinyoushituandui.png" class="cimg4"/> <span>200</span> </div>
                        <div class="companyDesc">专业团队</div>
                    </div>
                </div>
            </div>
            
            <!-- 主流代运营平台 -->
            <div class="serviceProcessOne operator">
                <div class="allTitle">
                    <p>主流代运营平台</p>
                </div>
                <div class="wow fadeInUp processInfo" data-wow-delay=".2s">
                    <img src="@/assets/img/industrialChain/wufuleirong_03.jpg" alt="">
                </div>
            </div>
            <!-- 代运营流程 -->
            <div class="serviceProcessOne">
                <div class="allTitle">
                    <p>服务流程</p>
                </div>
                <div class="wow fadeInUp processInfo" data-wow-delay=".2s">
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>01</div>
                                <span>海外零售平台开店<br/>商标注册<br/>品牌备案</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>02</div>
                                <span>项目调研<br>数据分析</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>03</div>
                                <span>视觉创意</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>04</div>
                                <span>推广、运营</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>05</div>
                                <span>客服问题<br>处理解答</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>06</div>
                                <span>物流支持</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>07</div>
                                <span>多平台选品<br>战略布局</span>
                            </div>
                        </div>
                        <div class="processArrow">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou.png">
                        </div>
                    </div>
                    <div class="processDiv">
                        <div class="processDesc">
                            <div class="process">
                                <div>08</div>
                                <span>海外品牌<br>内容孵化</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 核心优势 -->
            <div class="coreAdvantages">
                <div class="allTitle">
                    <p>核心优势</p>
                    <div>专注为中国品牌出海提供定制化、端到端的全渠道服务</div>
                </div>
                <div class="wow fadeInUp coreImgContent" data-wow-delay=".2s">
                    <div class="cicDiv">
                        <!-- :class="coreIndex == 1 ? 'moverImg':''" :class="coreIndex == 1 ? 'moverContent':''" @mouseenter="coreContentMover('1')" @mouseleave="coreContenOut" -->
                        <div class="coreContent" >
                            <div class="ccimg">
                                <img loading="lazy" src="@/assets/img/industrialChain/quanqudao.png" class="cimg3 cimgOne">
                                <img loading="lazy" src="@/assets/img/industrialChain/quanqudao-1.png" class="cimg3 cimgTwo">
                            </div>
                            <div class="cctitle">全渠道</div>
                            <div class="cccontent">在不同的渠道，品牌都希望消除边界，提供无缝的消费者购物场景，即无处不在、无时不在的商品提供服务体验和客户权益。而这需要强大的全渠道服务体系保证，包括全渠道的店站管理、跨渠道零售运营能力、整合的库存体系以及贸易和结算系统。</div>
                        </div>
                        <div class="coreImg" > <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_03.jpg"> </div>
                    </div>
                    <div>
                        <div class="coreContent">
                            <div class="ccimg">
                                <img loading="lazy" src="@/assets/img/industrialChain/jishuchuagxin.png" class="cimg1 cimgOne">
                                <img loading="lazy" src="@/assets/img/industrialChain/jishuchuagxin-2.png" class="cimg1 cimgTwo">
                            </div>
                            <div class="cctitle">技术与创新</div>
                            <div class="cccontent">今天的品牌电商发展推动了整体的零售模式变革，这一变革又引发了技术的变革，产生了巨大的创新空间。品牌出海链路长，触点多，为应付复杂的商业场景需求，胤石持续在零售系统、数据采集和分析、图像处理和识别、云计算等技术研发和应用领域投入，并坚信技术和创新会对品牌电商的发展产生本质的影响。</div>
                        </div>
                        <div class="coreImg"> <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_08.jpg"> </div>
                    </div>
                    <div class="cicDiv">
                        <div class="coreContent">
                            <div class="ccimg">
                                <img loading="lazy" src="@/assets/img/industrialChain/zhuanyituandui.png" class="cimg4 cimgOne">
                                <img loading="lazy" src="@/assets/img/industrialChain/zhuanyituandui-3.png" class="cimg4 cimgTwo">
                            </div>
                            <div class="cctitle">专业团队</div>
                            <div class="cccontent">多年沉淀的经营团队，高效运作，通力协作，提供专业的定制化运营服务</div>
                        </div>
                        <div class="coreImg">
                            <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_05.jpg">
                        </div>
                    </div>
                    <div>
                        <div class="coreContent">
                            <div class="ccimg">
                                <img loading="lazy" src="@/assets/img/industrialChain/yizhanshijiejuefangan.png" class="cimg2 cimgOne">
                                <img loading="lazy" src="@/assets/img/industrialChain/yizhanshijiejuefangan-4.png" class="cimg2 cimgTwo">
                            </div>
                            <div class="cctitle">端到端一站式解决方案</div>
                            <div class="cccontent">身为品牌商业管家，有效提升效率以运营为驱动力，更加灵活应变以数据为驱动力，不盲目追求KPI单项服务能力，富有行业竞争力</div>
                        </div>
                        <div class="coreImg"> <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_10.jpg"> </div>
                    </div>
                </div>
            </div>
            <!-- IT专家 -->
            <div class="ITExpert">
                <div class="allTitle">
                    <p>IT专家</p>
                    <div>科技基因驱动胤石不断创新，自主研发一系列自动化运营工具,并在专家团队的数据分析<br>下，赋能店站运营效率提升</div>
                </div>
                <div class="ITExpretInfo">
                    <div class="ITExpretOne">
                        <div class="wow fadeInLeft ITExpretDiv" data-wow-delay=".1s">
                            <div class="contentImg1">
                                <div class="content">店铺基础信息维护</div>
                            </div>
                        </div>
                        <div class="ITExpretDiv">
                            <div class="contentImg2">
                                <div class="content">视觉设计</div>
                            </div>
                        </div>
                        <div class="wow fadeInRight ITExpretDiv" data-wow-delay=".1s">
                            <div class="contentImg3">
                                <div class="content">商品上下架</div>
                            </div>
                        </div>
                    </div>
                    <div class="ITExpretTwo">
                        <div class="wow fadeInUp ITExpretDiv" data-wow-delay=".1s">
                            <div class="contentImg4">
                                <div class="content">活动管理</div>
                            </div>
                        </div>
                        <div class="wow fadeInUp ITExpretDiv" data-wow-delay=".25s">
                            <div class="contentImg5">
                                <div class="content">订单处理</div>
                            </div>
                        </div>
                        <div class="wow fadeInUp ITExpretDiv" data-wow-delay=".4s">
                            <div class="contentImg6">
                                <div class="content">报表分析</div>
                            </div>
                        </div>
                        <div class="wow fadeInUp ITExpretDiv" data-wow-delay=".55s">
                            <div class="contentImg7">
                                <div class="content">退款处理</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 综合性运营工具 -->
            <div class="operaToolAll">
                <div class="allTitle">
                    <p>综合性运营工具</p>
                    <div>围绕跨境电商场景独立开发的软件工具</div>
                </div>
                <div class="wow fadeInUp operaToolDiv" data-wow-delay=".15s">
                    <div class="operaToolOne">
                        <div class="operaTool">
                            <div class="operaToolTitle">cashcowERP</div>
                            <div class="operaToolContent">全渠道中台系统</div>
                        </div>
                        <div class="operaTool">
                            <div class="operaToolTitle">OMS</div>
                            <div class="operaToolContent">整合全渠道订单, 集中化自动处理</div>
                        </div>
                        <div class="operaTool">
                            <div class="operaToolTitle">CRM</div>
                            <div class="operaToolContent">在线客户服务,反馈通道,异常复盘</div>
                        </div>
                        <div class="operaTool">
                            <div class="operaToolTitle">PMS</div>
                            <div class="operaToolContent">面向供应链前端,改善企业与其供<br>应链上游供应商关系</div>
                        </div>
                    </div>
                    <div class="operaToolTwo">
                        <div class="operaTool">
                            <div class="operaToolTitle">WMS/TMS</div>
                            <div class="operaToolContent">为品牌实现可视化供应链中下游管理</div>
                        </div>
                        <div class="operaTool">
                            <div class="operaToolTitle">BI平台</div>
                            <div class="operaToolContent">垂直云行业的专业化服务, 解决账<br>号安全问题</div>
                        </div>
                        <div class="operaTool">
                            <div class="operaToolTitle">胤石云</div>
                            <div class="operaToolContent">为品牌提供智能化的商业数据服务</div>
                        </div>
                        <div class="operaTool">
                            <!-- <div class="operaToolTitle">展示</div>
                            <div class="operaToolContent">文本</div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 合作模式 -->
            <div class="cooperationModeAll">
                <div class="allTitle">
                    <p>合作模式</p>
                    <div>科技基因驱动胤石不断创新，自主研发一系列自动化运营工具,并在专家团队的数据分析下，赋能店站运营效率提升</div>
                </div>
                <div class="cooperationModeDiv">
                    <div class="wow fadeInLeft agencyOperation" data-wow-delay=".15s">
                        <div class="aoImg"><img loading="lazy" src="@/assets/img/industrialChain/fuwuleirong_27.jpg"></div>
                        <div class="aoInfo">
                            <div class="aoInfoImgTitle">
                                <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_daiyunying.png">
                                <span>代运营</span>
                            </div>
                            <div class="aoContent">
                                店铺与品牌所有权归属于客户，精英运营团队提供品牌精细化运营服务。帮助客户综合分析国内外贸易市场及政策，通过互联大数据分析精准把控品牌出海方向。
                            </div>
                        </div>
                    </div>
                    <div class="wow fadeInRight jointOperation" data-wow-delay=".15s">
                        <div class="aoImg"><img loading="lazy" src="@/assets/img/industrialChain/fuwuleirong_24.jpg"></div>
                        <div class="aoInfo">
                            <div class="aoInfoImgTitle">
                                <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_lianheyunying.png">
                                <span>联合运营</span>
                            </div>
                            <div class="aoContent">
                                我们单独持有品牌或与客户共同持有品牌。把控从供应链、产品运营到品牌建设各个环节，与优质客户深度合作，全方位科学运营，共同打造跨境超级品牌
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="serviceProcessTwo">
                <div class="allTitle">
                    <p>服务流程</p>
                </div>
                <div class="service">
                    <div class="wow fadeInLeft serviceImg">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_goutong.png">
                        <span>前期沟通</span>
                    </div>
                    <div class="wow fadeInLeft arrow" data-wow-delay=".1s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou01.png">
                    </div>
                    <div class="wow fadeInLeft serviceImg" data-wow-delay=".3s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_dinggou.png">
                        <span>前期沟通</span>
                    </div>
                    <div  class="wow fadeInLeft arrow" data-wow-delay=".5s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou01.png">
                    </div>
                    <div class="wow fadeInLeft serviceImg" data-wow-delay=".7s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiaojie.png">
                        <span>前期沟通</span>
                    </div>
                    <div  class="wow fadeInLeft arrow" data-wow-delay=".9s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou01.png">
                    </div>
                    <div class="wow fadeInLeft serviceImg" data-wow-delay="1.1s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_fangan.png">
                        <span>前期沟通</span>
                    </div>
                    <div  class="wow fadeInLeft arrow" data-wow-delay="1.3s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou01.png">
                    </div>
                    <div class="wow fadeInLeft serviceImg" data-wow-delay="1.5s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_fuwu.png">
                        <span>前期沟通</span>
                    </div>
                    <div  class="wow fadeInLeft arrow" data-wow-delay="1.7s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_jiantou01.png">
                    </div>
                    <div class="wow fadeInLeft serviceImg" data-wow-delay="1.9s">
                        <img loading="lazy" src="@/assets/img/industrialChain/daiyunying_shouhou.png">
                        <span>前期沟通</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteServiceContent',

    data() {
        return {
            coreIndex:0,
        };
    },

    mounted() {
        // new this.$WOW.WOW().init()
    },

    methods: {
        ...mapMutations(['GoTop']),
        // 鼠标移上去
        coreContentMover(idx){
            this.coreIndex = idx
        },
        // 鼠标移走
        coreContenOut(){
            this.coreIndex = 0
        }
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
    }
};
</script>

<style lang="scss" scoped>
// 全部
.serviceContent{
    // 顶部描述
    .scTopTip{
        height: 700px;
        background: #3b579ae7;
        display: flex;
        flex-direction: column;
        justify-content: center; 
        background: url(../../assets/img/companyProfile/gongsijianjie01_03.jpg);
        background-size:100% 100%;
        padding:0 270px;
        div:nth-child(1){
            font-size: 83px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #fff;
            padding-bottom: 79px;
            margin-top: -144px;
        }
        div:nth-child(2){
            font-size: 26px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 300;
            text-align: left;
            color: #e1e1e1;
        }
    }
    // 公司信息
    .companyInfoAll{
        padding-bottom:5px;
        border-bottom:1px solid #cacaca;
        .companyInfo{
            padding:0 270px;
            background: #eeeeee;
            height: 160px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // 每个div
            .company{
                display: flex;
                flex-direction: column;
                // 图片
                .companyImgInfo{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    span{
                        margin-left: 20px;
                        font-size: 22px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        text-align: center;
                        color: #444444;
                    }
                    a{
                        font-size: 22px;
                        color: #303030;
                        margin-top: -12px;
                    }
                }
                .cimg1{
                    width: 53px;
                    height: 49px;
                }
                .cimg2{
                    width: 50px;
                    height: 50px;
                }
                .cimg3{
                    width: 50px;
                    height: 50px;
                }
                .cimg4{
                    width: 61px;
                    height: 50px;
                }
                // 描述
                .companyDesc{
                    margin-top: 30px;
                    font-size: 30px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Light;
                    font-weight: 300;
                    text-align: center;
                    color: #666666;
                }

            }
        }
    }
    
    // 服务流程
    .serviceProcessOne{
        padding:70px 270px;
        background: #ffffff;
        // 所有的流程
        .processInfo{
            margin-top: 50px;
            display: flex;
            justify-content: space-between;
            // 单个的流程
            .processDiv{
                display: flex;
                // 描述
                .processDesc{
                    cursor: pointer;
                    .process{
                        width: 132px;
                        height: 140px;
                        // 标识
                        div{
                            width: 30px;
                            height: 30px;
                            background: #7492d7;
                            color:#fff;
                            font-size: 14px;
                            font-family: Arial, Arial-Regular;
                            font-weight: 400;
                            color: #ffffff;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 50%;
                            margin: 0 auto;
                            border:3px solid #7492d7;
                            transition:.2s;
                        }
                        // 描述文本
                        span{
                            display: inline-block;
                            width: 100%;
                            margin-top: 20px;
                            text-align: center;
                            font-size: 14px;
                            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                            font-weight: 400;
                            color: #666666;
                            line-height: 28px;
                            transition:.2s;
                        }
                    }
                    
                }
                .process:hover{
                    div{
                        background: #fff;
                        color:#7492d7;
                        width: 32px;
                        height: 32px;
                        font-size: 16px;
                    }
                    span{
                        font-size: 16px;
                        color:#7492d7;
                    }
                }
                // 箭头
                .processArrow{
                    display: flex;
                    align-items: center;
                    padding-left: 10px;
                    img{
                        width: 34px;
                        height: 14px;
                        -webkit-user-drag: none;
                    }
                }
            }
        }

    }
    // 主流代运营平台
    .operator{
        padding-bottom: 0px !important;
        .processInfo{
            display: flex;
            justify-content: center;
            img{
                width: 1380px;
                height: 300px;
            }
        }
    }
    // 核心优势
    .coreAdvantages{
        padding: 50px 270px;
        background: #eeeeee;
        // 图片和介绍
        .coreImgContent{
            margin-top: 50px;
            display: flex;
            // align-items: center;
            justify-content: center;
            overflow: hidden;
            background: #3b589a;
            .cicDiv{
                display: flex;
                flex-direction: column-reverse;
            }
            // 图片
            .coreImg{
                width: 345px;
                height: 335px;
                overflow: hidden;
                cursor: pointer;
                transition:.3s all;
                img{
                    width: 100%;
                    height: 100%;
                    transition: .3s;
                }
                img:hover{
                    transform: scale(1.07);
                }
            }
            // 文本
            .coreContent{
                width: 275px;
                height: 335px;
                background: #3b589a;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding:0 35px;
                transition: .3s all;
                cursor: pointer;
                // 小图片
                .ccimg{
                    margin-top: 45px;
                }
                // 标题
                .cctitle{
                    margin-top: 20px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    color: #fff;
                    transition: .3s all;
                }
                // 内容
                .cccontent{
                    margin-top: 40px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #fff;
                    line-height: 32px;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient:vertical;
                    -webkit-line-clamp:4;
                    transition: .3s all;
                }
            }
            // 小图标
            .cimg1{
                width: 48px;
                height: 48px;
            }
            .cimg2{
                width: 42px;
                height: 48px;
            }
            .cimg3{
                width: 48px;
                height: 47px;
            }
            .cimg4{
                width: 61px;
                height: 49px;
            }
            // 鼠标移上去   图片
            .coreContent:hover ~ .coreImg{
                // margin-top: -335px;
                opacity: 0;
                height: 0px !important;
            }
            // 鼠标移上去文本
            .coreContent:hover{
                height: 670px;
                background: #fff;
                justify-content: center;
                .cctitle{
                    margin-top:50px;
                    color: #444444;
                }
                .cccontent{
                    margin-top:60px;
                    color: #666666;
                    -webkit-line-clamp:99 !important;
                }
            }
            .cimgOne{
                display: none;
            }
            .coreContent:hover .cimgOne{
                display: block;
            }
            .coreContent:hover .cimgTwo{
                display: none;
            }
            .coreContent:hover .ccimg{
                margin-top: 20px;
            }
        }
    }
    // IT专家
    .ITExpert{
        padding:70px 270px 68px 270px;
        overflow-x: hidden;
        overflow-y: hidden;
        // 全部盒子
        .ITExpretInfo{
            margin-top: 50px;
            .ITExpretOne,.ITExpretTwo{
                display: flex;
                justify-content: space-between;
                .ITExpretDiv{
                    .contentImg1,.contentImg2,.contentImg3,.contentImg4,.contentImg5,.contentImg6,.contentImg7{
                        overflow: hidden;
                        cursor: pointer;
                        .content{
                            background:#3b579ab7;
                            width: 100%;
                            height: 100%;
                            color:#fff;
                            font-size: 16px;
                            font-weight: 700;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            transition:.3s;
                        }
                        .content:hover{
                            background:#3b579a56;
                        }
                    }
                }
            }
            .ITExpretOne{
                .ITExpretDiv{
                    .contentImg1,.contentImg2,.contentImg3{
                        width: 445px;
                        height: 280px;
                    }
                }
            }
            .ITExpretTwo{
                margin-top: 10px;
                .ITExpretDiv{
                    .contentImg4,.contentImg5,.contentImg6,.contentImg7{
                        width: 330px;
                        height: 280px;
                    }
                }
            }
            .contentImg1{
                background: url(../../assets/img/industrialChain/daiyunying_20.jpg);
                background-size:100% 100%;
            }
            .contentImg2{
                background: url(../../assets/img/industrialChain/daiyunying_15.jpg);
                background-size:100% 100%;
            }
            .contentImg3{
                background: url(../../assets/img/industrialChain/daiyunying_18.jpg);
                background-size:100% 100%;
            }
            .contentImg4{
                background: url(../../assets/img/industrialChain/daiyunying_28.jpg);
                background-size:100% 100%;
            }
            .contentImg5{
                background: url(../../assets/img/industrialChain/daiyunying_30.jpg);
                background-size:100% 100%;
            }
            .contentImg6{
                background: url(../../assets/img/industrialChain/daiyunying_26.jpg);
                background-size:100% 100%;
            }
            .contentImg7{
                background: url(../../assets/img/industrialChain/daiyunying_33.jpg);
                background-size:100% 100%;
            }
        }
    }
    // 综合性运营工具
    .operaToolAll{
        padding:50px 270px;
        background: #eeeeee;
        background: url(../../assets/img/industrialChain/daiyunying_01.jpg);
        background-size:100% 100%;
        // 内容
        .operaToolDiv{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 50px;
            // 第一组和第二组
            .operaToolOne,.operaToolTwo{
                display: flex;
            }
            // 每一个
            .operaTool{
                width: 346px;
                height: 206px;
                background: #ffffff;
                margin:1px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                // 标题
                .operaToolTitle{
                    background: #7492d7;
                    border-radius: 5px;
                    padding: 7px 43px;
                    font-size: 18px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    color: #ffffff;
                }
                // 内容
                .operaToolContent{
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #666666;
                    line-height: 28px;
                }

            }
        }

    }
    // 合作模式
    .cooperationModeAll{
        padding: 70px 270px;
        background: #fff;
        overflow-x: hidden;
        overflow-y: hidden;
        // 两个模式
        .cooperationModeDiv{
            display: flex;
            justify-content: space-between;
            margin-top: 50px;
            // 单个模式
            .agencyOperation,.jointOperation{
                background: #eeeeee;
                display: flex;
                // 图片
                .aoImg{
                    width: 228px;
                    height: 236px;
                    overflow: hidden;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                        transition: .2s;
                    }
                    img:hover{
                        transform: scale(1.1);
                    }
                }
                // 文本信息
                .aoInfo{
                    width: 390px;
                    height: 206px;
                    padding:30px 20px 0px 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    // 图片和标题
                    .aoInfoImgTitle{
                        display: flex;
                        align-items: center;
                        span{
                            margin-left: 40px;
                            font-size: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                            font-weight: 700;
                            color: #444444;
                        }
                    }
                    // 内容
                    .aoContent{
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #666666;
                        line-height: 32px;
                        margin-top: 40px;
                    }
                }
            }
            .agencyOperation .aoInfoImgTitle img{
                width: 54px;
                height: 52px;
            }
            .jointOperation .aoInfoImgTitle img{
                width: 61px;    
                height: 52px;
            }
        }

    }
    // 服务流程
    .serviceProcessTwo{
        padding: 0px 270px 70px 270px;
        // 所有流程图
        .service{
            margin-top: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // 图片
            .serviceImg{
                display: flex;
                flex-direction: column;
                align-items: center;
                img{
                    width: 116px;
                    height: 116px;
                    cursor: pointer;
                    -webkit-user-drag: none;
                }
                span{
                    margin-top:40px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #444444;
                    cursor: pointer;
                    transition: .13s;
                }
            }
            .serviceImg:hover{
                span{
                    color: #08a2e9;
                }
            }
            // 箭头
            .arrow{
                margin-top: -33px;
                img{
                    width: 29px;
                    height: 15px;
                    -webkit-user-drag: none;
                }
            }
        }
    }
}
// 所有标题

.allTitle{
    div{
        margin-top: 30px;
        color:#7492D7;
    }
}
</style>